'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const ServiceAreaMap = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const serviceAreas = [
    { name: 'Farwaniya', coverage: 'Full Coverage', icon: 'MapPinIcon' },
    { name: 'Hawally', coverage: 'Full Coverage', icon: 'MapPinIcon' },
    { name: 'Salmiya', coverage: 'Full Coverage', icon: 'MapPinIcon' },
    { name: 'Kuwait City', coverage: 'Full Coverage', icon: 'MapPinIcon' },
    { name: 'Jahra', coverage: 'Available', icon: 'MapPinIcon' },
    { name: 'Ahmadi', coverage: 'Available', icon: 'MapPinIcon' },
  ];

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-xl shadow-soft p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/2 mb-4"></div>
          <div className="h-64 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-soft p-6">
      <h3 className="text-xl font-headline font-bold text-text-primary mb-4">
        Our Service Areas
      </h3>
      
      {/* Map Container */}
      <div className="relative w-full h-64 lg:h-80 rounded-lg overflow-hidden mb-6">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="Almanara Moving Service Areas in Kuwait"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=29.2733,47.9742&z=11&output=embed"
          className="border-0"
        ></iframe>
      </div>

      {/* Service Areas List */}
      <div className="space-y-3">
        <p className="text-sm font-body text-text-secondary mb-3">
          We proudly serve the following areas in Kuwait:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {serviceAreas.map((area, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 p-3 rounded-lg bg-muted hover:bg-border transition-all duration-base"
            >
              <Icon
                name={area.icon as any}
                size={20}
                variant="solid"
                className="text-primary"
              />
              <div>
                <p className="font-body font-semibold text-text-primary">{area.name}</p>
                <p className="text-xs text-text-secondary font-body">{area.coverage}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Coverage Note */}
      <div className="mt-6 p-4 bg-primary bg-opacity-5 rounded-lg border border-primary border-opacity-20">
        <div className="flex items-start space-x-3">
          <Icon name="InformationCircleIcon" size={20} variant="solid" className="text-primary mt-0.5" />
          <div>
            <p className="text-sm font-body text-text-primary">
              <span className="font-semibold">Moving outside these areas?</span> Contact us for availability and custom pricing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceAreaMap;